import { inject, Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import { GetScenariosSuccessAction, ScenariosActions, SetScenariosSuccessAction } from './scenarios.actions';
import * as ScenariosSelector from './scenarios.selectors';

@Injectable({ providedIn: 'root' })
export class ScenariosFacade {
  private readonly store$ = inject(Store);
  protected actions$ = inject(Actions);

  scenarios$ = this.store$.pipe(select(ScenariosSelector.getScenarios));
  moduleScenarios$ = this.store$.pipe(select(ScenariosSelector.getModuleScenarios));
  defaultScenarios$ = this.store$.pipe(select(ScenariosSelector.defaultScenarios));
  customScenarios$ = this.store$.pipe(select(ScenariosSelector.customScenarios));

  loadScenarios(homeId: string, deviceTypes?: string[], filter?: string[]): Observable<GetScenariosSuccessAction> {
    this.store$.dispatch(ScenariosActions.getScenarios({ homeId, deviceTypes, filter }));

    return this.actions$.pipe(
      ofType(ScenariosActions.getScenariosSuccess),
      take(1),
    );
  }

  setScenarios(params): Observable<SetScenariosSuccessAction> {
    this.store$.dispatch(ScenariosActions.setScenarios({ params }));

    return this.actions$.pipe(
      ofType(ScenariosActions.setScenariosSuccess),
      take(1),
    );
  }
}
